import React, { useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import "./styles.css";
import SplitForm from "./SplitForm";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    borderRadius: "4px",
    margin: "8px 0 0 0",
    "&:before": {
      display: "none",
    },
    // "&$expanded": {
    //   margin: "0",
    // },
  },
});

const ExpandContainer = (props) => {
  const classes = useStyles();
  const { upgrade } = props;
  const [expand, setExpand] = useState(false);
  useEffect(() => {
    setExpand(upgrade);
  }, [upgrade])
  const handleAccordClick = (e) => {
    setExpand(!expand);
  };
  return (
    <Accordion
      expanded={expand}
      name="accordion"
      className={classes.root}
      // onClick={(e) => handleAccordClick(e)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1c-content"
        id="panel1c-header"
        IconButtonProps={{
          onClick: handleAccordClick,
        }}
      >
        <Typography>Payment</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <SplitForm />
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandContainer;
